export default "__VITE_ASSET__DGYu6EDx__"